'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { HiMicrophone } from 'react-icons/hi2';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { twMerge } from 'tailwind-merge';
import { Button, CruzIcon, Modal } from '@/components';
type Props = {
  onTranscriptAction: (transcript: string) => void;
};
export const VoiceRecognition = t0 => {
  const $ = _c(41);
  const {
    onTranscriptAction
  } = t0;
  const [mounted, setMounted] = useState(false);
  const {
    transcript,
    listening,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable
  } = useSpeechRecognition();
  const [showModal, setShowModal] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isMicrophoneAvailable) {
    t1 = () => {
      if (!isMicrophoneAvailable) {
        SpeechRecognition.stopListening();
      }
    };
    t2 = [isMicrophoneAvailable];
    $[0] = isMicrophoneAvailable;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setMounted(true);
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== onTranscriptAction || $[6] !== transcript) {
    t5 = () => {
      if (transcript) {
        onTranscriptAction(transcript);
      }
    };
    $[5] = onTranscriptAction;
    $[6] = transcript;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== transcript) {
    t6 = [transcript];
    $[8] = transcript;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== listening) {
    t7 = () => {
      if (listening) {
        const timer = setTimeout(_temp, 3500);
        return () => clearTimeout(timer);
      }
    };
    $[10] = listening;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== listening || $[13] !== transcript) {
    t8 = [listening, transcript];
    $[12] = listening;
    $[13] = transcript;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t9;
  if ($[15] !== isMicrophoneAvailable || $[16] !== listening) {
    t9 = () => {
      if (!isMicrophoneAvailable) {
        setShowModal(true);
        return;
      }
      if (listening) {
        SpeechRecognition.stopListening();
      } else {
        SpeechRecognition.startListening({
          continuous: true
        });
      }
    };
    $[15] = isMicrophoneAvailable;
    $[16] = listening;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const toggleListening = t9;
  if (!mounted || !browserSupportsSpeechRecognition) {
    return null;
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h3 className="font-bold text-lg text-zinc-900 dark:text-white">Microphone is not available</h3>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setShowModal(false);
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <section className="flex items-center justify-between">{t10}<Button type="button" variant="transparent" onClick={t11} className="-mr-2 size-12 rounded-full" aria-label="Close modal"><CruzIcon.Close className="size-5" aria-hidden="true" /></Button></section>;
    t13 = <p className="text-sm mt-4 mb-6 leading-relaxed">It looks like your browser or device does not support the required microphone features, or your microphone access has been blocked. Please check your settings and ensure your microphone is properly configured.</p>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t12 = $[20];
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex justify-end"><Button type="button" onClick={() => setShowModal(false)}>Close</Button></div>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== showModal) {
    t15 = <Modal open={showModal} setOpen={setShowModal} className="p-6 w-full max-w-md bg-white dark:bg-zinc-800 rounded-xl">{t12}{t13}{t14}</Modal>;
    $[23] = showModal;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = listening ? "Stop Listening" : "Start Listening";
  const t17 = listening ? "Stop voice recognition" : "Start voice recognition";
  const t18 = listening && "animate-pulse text-red-800";
  let t19;
  if ($[25] !== t18) {
    t19 = twMerge("peer size-6 dark:text-zinc-400", t18);
    $[25] = t18;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t19) {
    t20 = <HiMicrophone className={t19} />;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== listening || $[30] !== t16 || $[31] !== t17 || $[32] !== t20 || $[33] !== toggleListening) {
    t21 = <button type="button" className="mx-4 pl-3 hover:text-red-800" title={t16} aria-label={t17} aria-pressed={listening} onClick={toggleListening}>{t20}</button>;
    $[29] = listening;
    $[30] = t16;
    $[31] = t17;
    $[32] = t20;
    $[33] = toggleListening;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  const t22 = listening ? "Voice recognition is active and listening" : "Voice recognition is off";
  let t23;
  if ($[35] !== t22) {
    t23 = <span className="sr-only" aria-live="polite">{t22}</span>;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t15 || $[38] !== t21 || $[39] !== t23) {
    t24 = <>{t15}{t21}{t23}</>;
    $[37] = t15;
    $[38] = t21;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  return t24;
};
function _temp() {
  SpeechRecognition.stopListening();
}